import requestFormData from '../../utils/requestFormData';
import request from '../../utils/request';

export function getCarrierIntegrations(params) {
  return request(`/carriers/integrations`, {
    method: 'GET',
    params,
  });
}

export function getCarriers(params) {
  return request(`/carriers`, {
    method: 'GET',
    params,
  });
}

export function createCarrier(params) {
  return requestFormData(`/carriers`, {
    method: 'POST',
    data: params,
  });
}

export function updateCarrier(params) {
  // FormData needs the .get() method to fetch values
  const id = params.get('id');
  params.delete('id');

  return requestFormData(`/carriers/${id}`, {
    method: 'PATCH',
    data: params,
  });
}

export function doCreateCarrierIntegration(params) {
  return request(`/carriers/integrations`, {
    method: 'POST',
    data: params,
  });
}

export function doUpdateCarrierIntegration(params) {
  const { id } = params;
  return request(`/carriers/integrations/${id}`, {
    method: 'PATCH',
    data: params,
  });
}

export function doGetCarrier(params) {
  const { id } = params;
  return request(`/carriers/${id}`, {
    method: 'GET',
    data: params,
  });
}

export function createCarrierHub(params) {
  const { carrierId, ...createData } = params;
  return request(`/carriers/${carrierId}/create-hub`, {
    method: 'POST',
    data: createData,
  });
}

export function updateCarrierHub(params) {
  const { carrierId, ...updateData } = params;
  return request(`/carriers/${carrierId}/update-hub`, {
    method: 'PATCH',
    data: updateData,
  });
}

export function deleteCarrierHub(params) {
  const { carrierId, carrierHubId } = params;
  return request(`/carriers/${carrierId}/delete-hub/${carrierHubId}`, {
    method: 'DELETE',
  });
}
